export const notifications = {
    quickCapture: {
        saved_one: 'Captura adicionada às Pendências',
        saved_other: '{{count}} capturas adicionadas às Pendências',
        failedTitle: 'Não consegui ler uma captura',
        failedBody: 'Tente novamente pelo Atalhos ou informe o valor manualmente.',
    },
    // app/notifications/banks.tsx — gerenciar bancos monitorados
    banks: {
        title: 'Bancos',
        searchPlaceholder: 'Buscar banco…',
        activeLabel: 'Ativos · {{total}}',
        availableLabel: 'Disponíveis · {{total}}',
        activate: 'Ativar',
        empty: 'Nenhum banco encontrado',
        deactivateA11y: 'Desativar {{bank}}',
    },

    // app/notifications/index.tsx — caixa de pendentes + onboarding/bloqueio da captura
    inbox: {
        title: 'Notificações',
        iosTitle: 'Pendências',
        dismissAllTitle: 'Descartar todas',
        dismissAllMessage: 'Deseja descartar todas as notificações pendentes?',
        cancel: 'Cancelar',
        dismiss: 'Descartar',

        // Selos de estado dos cartões de permissão
        badgeActive: 'Ativo',
        badgeBlocked: 'Bloqueado',
        badgeChecking: 'Verificando',
        badgePending: 'Pendente',
        recoveryPath: 'Caminho de recuperação',

        // Cartão do listener (leitura das notificações bancárias)
        listenerTitle: 'Leitura das notificações bancárias',
        listenerActiveDesc: 'O listener Android está ligado e pode capturar compras, Pix, TED e boletos.',
        listenerBlockedDesc: 'O Android bloqueou o acesso. Sem isso, novas pendências não entram automaticamente.',
        listenerPendingDesc: 'O listener ainda não foi liberado. Ative para capturar movimentações dos bancos suportados.',
        listenerActionBlocked: 'Abrir acesso a notificações',
        listenerAction: 'Ativar leitura bancária',
        listenerRecoveryPath: 'Android > Apps > Acesso especial > Acesso a notificações > Kontto',

        // Cartão dos alertas locais (lembretes)
        reminderTitle: 'Alertas locais e lembretes',
        reminderActiveDesc: 'Os avisos locais e lembretes podem reaparecer no aparelho assim que algo novo chegar.',
        reminderBlockedDesc: 'O app continua lendo notificações, mas você perde o aviso local e os lembretes até liberar o Android.',
        reminderPendingDesc: 'Ative para receber aviso quando uma pendência for capturada e para sincronizar lembretes locais.',
        reminderActionBlocked: 'Abrir ajustes do app',
        reminderAction: 'Ativar alertas locais',
        reminderRecoveryPath: 'Android > Apps > Kontto > Notificações',

        // Aviso de captura muda (batimento do listener; ver lib/notificationListenerHealth):
        // a permissão diz "authorized", mas nenhuma notificação chega ao app há mais de um dia.
        healthSilentTitle: 'A leitura parou de receber notificações',
        healthSilentDesc: 'O acesso está concedido, mas nada chega ao app há mais de um dia. Isso costuma ser o Android que congelou a conexão — reconecte abaixo.',
        healthRestrictedDesc: 'O Android está bloqueando o Kontto em segundo plano (bateria restrita). Libere a bateria e reconecte a leitura.',
        healthBatteryRecoveryPath: 'Android > Apps > Kontto > Bateria > Sem restrições',
        healthActionRebind: 'Reconectar leitura',
        healthActionBattery: 'Abrir ajustes do app',
        healthRebindTitle: 'Reconexão solicitada',
        healthRebindMessage: 'Pedimos ao Android pra religar a leitura. Faça um teste: gere uma movimentação com notificação (um Pix, por exemplo) e veja se ela aparece aqui.',
        healthRebindUnavailableTitle: 'Reconexão indisponível nesta versão',
        healthRebindUnavailableMessage: 'Desligue e ligue o acesso em Acesso a notificações nos Ajustes do Android, ou reinicie o aparelho.',
        // Despacho travado: o Android entrega as notificações, mas elas não chegam ao
        // app — reconectar não resolve; só um processo novo (reiniciar o app).
        healthStuckTitle: 'A leitura travou neste aparelho',
        healthStuckDesc: 'As notificações estão chegando ao Android, mas não ao Kontto. Reiniciar o app resolve — leva só um piscar de tela.',
        healthActionRestart: 'Reiniciar o app',
        healthRestartUnavailableTitle: 'Reinício indisponível nesta versão',
        healthRestartUnavailableMessage: 'Force o encerramento na mão: Ajustes do Android > Apps > Kontto > Forçar parada. Depois abra o Kontto de novo.',
        // Sonda ativa: notificação de teste que prova a leitura de ponta a ponta.
        probeButton: 'Testar leitura agora',
        probeRunning: 'Testando a leitura…',
        probeOkTitle: 'Leitura funcionando',
        probeOkMessage: 'A notificação de teste atravessou a leitura de ponta a ponta. Está tudo vivo.',
        // Bateria Restrita: a sonda em foreground passa, mas o background segue morto.
        probeOkRestrictedTitle: 'Funciona só com o app aberto',
        probeOkRestrictedMessage: 'A notificação de teste passou, mas o Android está bloqueando o Kontto em segundo plano — com o app fechado, nada é capturado. Libere em: Ajustes > Apps > Kontto > Bateria > Sem restrições.',
        probeDeadTitle: 'A leitura não respondeu',
        probeDeadMessage: 'A notificação de teste não chegou ao app. Toque em Reconectar leitura; se não resolver, use Reiniciar o app (ou force o encerramento nos Ajustes).',
        probeUnavailableTitle: 'Teste indisponível',
        probeUnavailableMessage: 'Para testar, o Kontto precisa da permissão de enviar notificações (é ela que cria a notificação de teste). Ative em Ajustes > Apps > Kontto > Notificações.',
        // Xiaomi/Redmi/POCO: sem Autostart a MIUI/HyperOS não religa o serviço, e a
        // tela de bateria do Android não tem essa chave.
        healthAutostartTitle: 'No seu aparelho, ligue também o Autostart',
        healthAutostartPath: 'Ajustes > Apps > Gerenciar apps > Kontto > Início automático',
        // Nenhuma tela de acesso a notificações respondeu (ROM capada)
        accessUnavailableTitle: 'Não consegui abrir essa tela',
        accessUnavailableMessage: 'Abra na mão: Ajustes do Android > Apps > Acesso especial > Acesso a notificações > Kontto.',

        // Resumo de captura no topo da lista
        captureActiveTitle: 'Captura ativa',
        capturePartialTitle: 'Captura parcial',
        captureActiveSubtitle: 'Leitura e alertas funcionando',
        capturePartialSubtitle: 'Leitura ativa · ative os alertas locais',

        banksMonitored: 'Bancos monitorados',
        activeOfTotal_one: '{{count}} ativo de {{total}} disponíveis',
        activeOfTotal_other: '{{count}} ativos de {{total}} disponíveis',
        manage: 'Gerenciar',
        valesTitle: 'Vales e benefícios',
        valeAvailableHint: '{{total}} disponíveis · toque para ativar',
        smsTitle: 'SMS dos bancos',
        smsOnHint: 'Lendo SMS de compra dos bancos monitorados',
        smsOffHint: 'Desativado · toque para ativar',
        pendingHeader: 'Pendentes · {{total}}',
        iosCaptureTitle: 'Captura rápida no iPhone',
        iosCaptureSubtitle: 'Apple Pay e os lançamentos pelos dois toques entram aqui para revisão.',
        iosCaptureSubtitleBank: 'Notificações do banco, Apple Pay e dois toques entram aqui para revisão.',
        iosCaptureManage: 'Configurar',

        // Onboarding de primeiro acesso
        heroTitle: 'Lance tudo sozinho',
        heroSubtitle: 'O Kontto lê as notificações dos seus apps bancários e detecta compras, Pix, TED e boletos automaticamente — você só confirma.',
        step1Title: 'Acesso às notificações',
        step1Desc: 'Para capturar as movimentações',
        step2Title: 'Alertas e lembretes',
        step2Desc: 'Avisa quando algo novo chega',
        privacyNote: 'Tudo fica no seu aparelho. Nada é enviado para servidores externos.',
        banksSupported: '{{total}} bancos suportados',
        wallMore: '+{{total}}',

        // Tela de acesso bloqueado
        blockedTitle: 'Acesso bloqueado',
        blockedSubtitle: 'O Android revogou o acesso às notificações. Sem ele, novas movimentações não entram sozinhas. Reative em poucos passos.',
        openAndroidSettings: 'Abrir configurações do Android',
        howToReactivate: 'Como reativar',
        reactivateStep1: 'Abra as Configurações do Android',
        reactivateStep2: 'Apps › Acesso especial › Acesso a notificações',
        reactivateStep3: 'Ative o Kontto na lista',
        blockedRecoveryPath: 'Android › Apps › Acesso especial › Acesso a notificações › Kontto',
        pausedNote: 'Enquanto bloqueado, a captura automática fica pausada',

        // Estado vazio da lista de pendentes
        emptyTitle: 'Nenhuma transação pendente',
        emptySubtitle: 'Quando seus apps bancários enviarem notificações de compras, Pix, TED ou boletos, eles aparecerão aqui para confirmar.',
        iosEmptySubtitle: 'Use o Apple Pay automático ou os dois toques para lançar um gasto sem abrir o Kontto.',
    },

    // lib/captureProbe.ts — a notificação de teste da sonda (canal silencioso,
    // some sozinha em segundos; o corpo carrega o marcador KonttoProbe:<nonce>)
    probe: {
        channelName: 'Teste da leitura de notificações',
        title: 'Kontto',
        body: 'Verificando a leitura de notificações…',
    },

    // app/notifications/vouchers.tsx — gerenciar vales/benefícios (recurso Pro)
    vouchers: {
        title: 'Vales e benefícios',
        intro: 'Como você é Pro, o Kontto já lê sozinho as notificações de compra dos seus cartões de benefício e cria lançamentos para você confirmar. Desligue aqui o que não quiser — a escolha fica salva.',
        introFree: 'Com o Pro, o Kontto lê sozinho as notificações de compra dos seus cartões de benefício e cria lançamentos para você confirmar. Todos ligam de uma vez ao assinar.',
        reading: 'Lendo compras',
        notReading: 'Compras no cartão',
        activateA11y: 'Ativar {{vale}}',
        deactivateA11y: 'Desativar {{vale}}',
    },

    // app/notifications/sms.tsx — canal de SMS bancário (ADR 0048)
    sms: {
        title: 'SMS dos bancos',
        intro: 'Alguns bancos ainda avisam compras por SMS. O Kontto lê a notificação do app de mensagens — nunca a sua caixa de SMS — e só de remetentes bancários conhecidos. O resto é ignorado na hora.',
        toggleTitle: 'Ler SMS de compra',
        reading: 'Lendo SMS dos bancos monitorados',
        notReading: 'Desativado',
        activateA11y: 'Ativar leitura de SMS bancário',
        deactivateA11y: 'Desativar leitura de SMS bancário',
        privacyNote: 'Mensagens pessoais nunca são lidas nem guardadas. Só SMS de banco vira sugestão de lançamento — e você confirma cada um.',
        filtersNote: 'Os bancos ativados e as palavras ignoradas em "Bancos monitorados" valem também para o SMS.',
        banksSupported: '{{total}} bancos com SMS mapeado',
    },

    // app/notification-primer.tsx — primer de auto-detecção (Android)
    primer: {
        // Pílula de contexto (não é faixa): frase curta, só pra ancorar de onde a tela veio.
        onboardingPill: 'Configuração concluída!',
        // Pós-oferta de ativação (ADR 0071): o 1º gasto acabou de ser salvo à mão.
        activationPill: 'Primeiro gasto salvo!',
        title: 'Deixa que o Kontto anota',
        subtitle: 'Quando o banco avisa uma compra, o lançamento já aparece pronto aqui — só falta o seu ok.',
        // Exemplo com banco real (logo do Nubank) — genérico ("Seu banco") não convencia
        // de que a leitura é da notificação que a pessoa já recebe.
        exampleNotifHeader: 'Nubank · agora',
        // Os trechos entre asteriscos saem em negrito (ver renderHighlighted no primer).
        exampleNotifText: 'Compra aprovada de *R$ 32,90* em *PADARIA DOCE PÃO*',
        exampleMerchant: 'Padaria Doce Pão',
        exampleSuggestionMeta: 'Despesa · Alimentação · a confirmar',
        exampleAmount: 'R$ 32,90',
        guaranteePrivacy: 'Nada sai do seu celular — o Kontto não envia seus dados pra lugar nenhum.',
        guaranteeConfirm: 'Você confirma cada lançamento antes de salvar.',
        activate: 'Quero ativar agora',
        // Microcópia do rodapé: absorve o antigo "guaranteeToggle" e diz o tamanho do esforço.
        activateHint: 'É só ligar uma chave · desliga quando quiser',
        dismiss: 'Prefiro anotar na mão',
        // Resultado conferido na volta dos Ajustes — antes a tela saía sem checar nada.
        grantedTitle: 'Pronto, leitura ativada',
        grantedDesc: 'Na próxima compra o Kontto já sugere o lançamento aqui.',
        // Voltou dos Ajustes sem ativar: aí sim o passo a passo toma a tela inteira.
        retryTitle: 'Faltou só um toque',
        retryDesc: 'A chave do Kontto ainda está desligada nos Ajustes. É rapidinho:',
        retryStep1Title: 'Toque em “Tentar de novo”',
        retryStep1Desc: 'Abrimos os Ajustes do Android pra você.',
        retryStep2Title: 'Ligue a chave do Kontto',
        retryStep3Title: 'Volte pro Kontto',
        retryStep3Desc: 'A gente confere aqui se deu tudo certo.',
        retryPathPrefix: 'Se não achar:',
        retryDismiss: 'Deixar pra depois',
        done: 'Pronto',
        retry: 'Tentar de novo',
    },

    // app/ios-bank-capture-primer.tsx — leitura das notificações do banco no iPhone (iOS 27+,
    // ADR 0152). Reaproveita o exemplo e a garantia de confirmação de `primer`.
    iosPrimer: {
        newPill: 'Novo no iOS 27',
        title: 'O iPhone agora anota sozinho',
        subtitle: 'Quando o banco avisa um Pix ou uma compra, o lançamento aparece pronto aqui. Você só confere.',
        guaranteePrivacy: 'A notificação é lida no seu iPhone. Nada vai para servidor nenhum.',
        step1Title: 'Adicione o atalho do Kontto',
        step1Desc: 'Toque no botão abaixo e confirme em “Adicionar Atalho”.',
        step2Title: 'Ligue a automação',
        step2Desc: 'No app Atalhos, vá em Biblioteca › Automação e ligue “Quando eu receber uma notificação de um dos… apps”. Ela chega desligada.',
        step3Title: 'Pronto',
        step3Desc: 'A próxima notificação do seu banco vira um lançamento para você conferir.',
        add: 'Adicionar ao Atalhos',
        addHint: 'Nubank, Itaú, Inter, C6 e mais 40 bancos · 1 minuto',
        confirm: 'Já liguei a automação',
        openShortcuts: 'Abrir o app Atalhos',
        dismiss: 'Agora não',
        doneTitle: 'Pronto, leitura ligada',
        doneDesc: 'Na próxima notificação do banco o lançamento aparece em Pendências. Se mudar de ideia, fica em Ajustes → Captura rápida.',
        openFailed: 'Não deu para abrir o Atalhos. Tente de novo.',
    },

    // components/notifications/BankDetailSheet.tsx — detalhe do banco (tipos + palavras)
    bankDetail: {
        typesActive: '{{enabled}} de {{total}} tipos ativos',
        disabled: 'Banco desativado',
        activateA11y: 'Ativar {{bank}}',
        typesSection: 'Tipos de transação',
        excludedSection: 'Palavras ignoradas',
        addWordPlaceholder: 'Adicionar palavra…',
        excludedHint: 'Notificações com essas palavras serão ignoradas',
    },

    // components/notifications/ConfirmTransactionSheet.tsx — confirmar lançamento
    confirm: {
        accountErrorReceived: 'Selecione a conta que recebeu.',
        accountErrorSent: 'Selecione a conta que enviou.',
        accountErrorDefault: 'Selecione a conta.',
        accountLabel: 'Conta',
        accountLabelReceive: 'Recebido em',
        accountLabelPay: 'Pago com',
        accountPlaceholder: 'Selecionar conta...',
        settleReceive: 'Sim, dar baixa',
        settleBill: 'Sim, dar baixa',
        confirmIncome: 'Confirmar entrada',
        confirmExpense: 'Confirmar saída',
        confirm: 'Confirmar',
        dismiss: 'Descartar',
        dismissItem: 'Descartar {{name}}',
        descriptionPlaceholder: 'Adicionar descrição',
        cardLabel: 'Cartão',
        cardPlaceholder: 'Selecionar cartão...',
        installmentsLabel: 'Parcelas',
        installmentsValue: '{{n}}× de {{amount}}',
        installmentsCash: 'À vista',
        installmentDecrease: 'Menos uma parcela',
        installmentIncrease: 'Mais uma parcela',
        installmentCountA11y: 'Número de parcelas',
        transferSourceLabel: 'Conta de origem',
        transferDestinationLabel: 'Conta de destino',
        categoryLabel: 'Categoria',
        categoryPlaceholder: 'Selecionar categoria...',
        suggestedFromHistory: 'Sugerido pelo histórico',
        suggestedFromContext: 'Sugerido pelo dia e horário',
        suggestedFromSimilar: 'Sugerido por lançamentos parecidos',
        suggestedFromMarketplace: 'Você costuma lançar {{name}} assim',
        suggestedFromCatalog: 'Sugestão do app para esta loja',
        contextAlternative: 'Ou talvez {{name}}',
        useContextAlternative: 'Usar',
        // Nome lembrado e observações (ADR 0198).
        rememberedName: 'Nome que você usou da última vez',
        useOriginalName: 'Usar o original',
        notesLabel: 'Observações',
        notesPlaceholder: 'Observações',
        clearNotes: 'Limpar observações',
        change: 'Trocar',
        addTags: 'Adicionar tags',
        // Linha "Tipo" + seletor (ADR 0134): uma pergunta no lugar de direção + caixas.
        typeLabel: 'Tipo',
        typePlaceholder: 'Escolher o tipo',
        typeReadHint: 'lido do banco',
        typeReadReceiptHint: 'lido do comprovante',
        typeChangedHint: 'alterado',
        typeSheetTitle: 'O que foi essa movimentação?',
        typeSheetSubtitle: '{{bank}} leu como {{type}} · {{amount}}',
        typeSheetSubtitleUnknown: '{{bank}} não disse o tipo · {{amount}}',
        typeSheetSubtitleReceipt: 'No comprovante: {{type}} · {{amount}}',
        typeSheetSubtitleReceiptUnknown: 'O comprovante não diz o tipo · {{amount}}',
        kindExpense: 'Saída da conta',
        kindExpenseHint: 'Gasto, pagamento ou Pix pra alguém',
        kindDebit: 'Compra no débito',
        kindDebitHint: 'Sai do saldo da conta, não vai pra fatura',
        kindIncome: 'Entrada na conta',
        kindIncomeHint: 'Recebimento, salário, reembolso',
        kindCard: 'Compra no cartão de crédito',
        kindCardHint: 'Vai pra fatura, pode parcelar',
        kindTransfer: 'Transferência entre contas',
        kindTransferHint: 'Não é gasto nem ganho — só mudou de lugar',
        kindReserva: 'Guardar em caixinha',
        kindReservaHint: 'Dinheiro reservado, sem virar despesa',
        kindSettle: 'Pagamento de conta agendada',
        kindSettleIncome: 'Recebimento agendado',
        kindSettleCard: 'Cobrança já lançada na fatura',
        kindSettleFinancing: 'Parcela de financiamento',
        kindSettleLoan: 'Acerto de valor a receber',
        kindSettleHint: 'Dá baixa em {{name}}',
        transfer: 'Transferência',
        reservaChip: 'Caixinha',
        reservaLabel: 'Caixinha',
        reservaPlaceholder: 'Selecionar caixinha...',
        reservaSheetTitle: 'Selecionar caixinha',
        confirmReserva: 'Guardar',
        confirmReservaTransfer: 'Transferir e guardar',
        reservaSourceLabel: 'Sai da conta',
        reservaCrossNote: 'Cria a transferência pra conta {{dest}} e guarda na caixinha.',
        reservaPartialTitle: 'Guardado em parte',
        reservaPartialBody: 'Coube {{amount}} no Disponível da conta — o restante ficou de fora.',
        amountInvalid: 'Informe um valor maior que zero.',
        original: 'Original: {{amount}}',
        fixedRate: 'Taxa fixa: 1 {{source}} = {{rate}}',
        directionExpense: 'Saída',
        directionIncome: 'Entrada',
        // Com candidata, o sheet abre na pergunta (ADR 0134).
        matchIncomeTitle: 'É este recebimento agendado?',
        matchBillTitle: 'É o pagamento desta conta agendada?',
        matchCardTitle: 'É esta cobrança já lançada na fatura?',
        matchFinancingTitle: 'É a parcela de {{name}}?',
        matchLoanTitle: 'É o acerto de {{name}}?',
        matchMetaForecast: 'previsto para {{date}}',
        matchMetaDue: 'vence {{date}}',
        matchMetaDuePast: 'venceu {{date}}',
        matchMetaPurchase: 'lançado em {{date}}',
        matchDateToday: 'hoje, {{date}}',
        matchDateTomorrow: 'amanhã, {{date}}',
        matchAmountDiffAbove: '+ {{difference}}',
        matchAmountDiffBelow: '− {{difference}}',
        notThisBill: 'Não é essa conta',
        notThisIncome: 'Não é esse recebimento',
        notThisCard: 'Não é essa cobrança',
        notThisFinancing: 'Não é essa parcela',
        notThisLoan: 'Não é esse acerto',
        stillScheduledBill: '{{name}} continua agendada',
        stillScheduledIncome: '{{name}} continua prevista',
        stillScheduledCard: '{{name}} continua na fatura',
        stillScheduledFinancing: 'A parcela de {{name}} continua em aberto',
        stillScheduledLoan: 'O saldo de {{name}} continua em aberto',
        linkMatch: 'Vincular',
        invoiceHintTitle: 'Parece pagamento de fatura',
        invoiceHintBody: 'Confirmar aqui cria uma despesa comum, e a fatura continua em aberto — o valor contaria duas vezes. Pague pela tela do cartão.',
        invoiceHintAction: 'Ir para a fatura',
        settleHelper: 'O lançamento agendado será concluído com a data e a conta desta notificação, sem criar um novo.',
        settleCardHelper: 'A cobrança já lançada na fatura é confirmada com a data desta notificação — nada novo entra na fatura.',
        settleFinancingHelper: 'A parcela é marcada como paga com a data e a conta desta notificação, sem criar um lançamento novo.',
        settleLoanHelper: 'O valor abate o saldo em aberto de {{name}}, em vez de virar receita avulsa.',
        settleRecurringHelper: 'Esta ocorrência da recorrência é concluída com a data e a conta desta notificação. A repetição segue normalmente nas próximas.',
        settlePaidOnCardHelper: 'Pago no cartão: o lançamento agendado sai de {{account}} e entra na fatura do {{card}}, sem criar um novo.',
        settleRecurringPaidOnCardHelper: 'Pago no cartão desta vez: só esta ocorrência vai para a fatura do {{card}}. As próximas continuam em {{account}}.',
        settleAmountNote: 'Fica com o valor desta notificação, {{amount}}.',
        settleRecurringAmountNote: 'Esta fica com {{amount}}; as próximas seguem previstas em {{expected}}.',
        settleRecurringGone: 'A recorrência não está mais ativa. Feche e confirme de novo para criar um lançamento novo.',
        settleCard: 'Sim, confirmar cobrança',
        settleFinancing: 'Sim, pagar parcela',
        settleLoan: 'Sim, registrar recebimento',
        cardLabelSettle: 'Fatura do cartão',
        cardLabelPaidOnCard: 'Pago no cartão',
        errorTitle: 'Não foi possível confirmar',
        errorFallback: 'Tente novamente.',
    },

    // components/notifications/PendingNotificationsSection.tsx — bloco na Home
    pending: {
        sectionTitle: 'Pendentes ({{total}})',
    },
};
